'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';

import uiBootstrap from 'angular-ui-bootstrap';
//import jquery from 'jquery';
//import slick from 'slick-carousel';

import {
  routeConfig
} from './app.config';

import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import busList from './main/bus-list/bus-list.component';
import busDetail from './main/bus-detail/bus-detail.component';
import service from './main/service/service.component';
import shortTrip from './main/service/shortTrip.component';
import prevention from './main/service/prevention.component';
import strength from './main/service/strength.component';
import safety from './main/service/safety.component';
import contribution from './main/service/contribution.component';
import company from './main/company/company.component';
import companyTop from './main/company/companyTop.component';
import statement from './main/company/statement.component';
import covidNotice from './main/company/covidNotice.component';
import about from './main/company/about.component';
import access from './main/company/access.component';
import group from './main/company/group.component';
import others from './main/others/others.component';
import constants from './app.constants';
import util from '../components/util/util.module';

import './app.scss';

angular.module('fukuichuoKankoApp', [ngCookies, ngResource, ngSanitize, uiRouter, uiBootstrap,
  navbar, footer, main, constants, util, busList, busDetail, service, prevention, shortTrip, strength, safety, contribution,
  company, covidNotice, companyTop, statement, about, access, group, others
])
  .config(routeConfig);

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['fukuichuoKankoApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js